module.exports = __webpack_public_path__ + "media/images/generic-avatar-a00bab1852c6a916f8f3f24d62f38fac.png";